"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungFormatter = void 0;
const LeitungFormValidator_1 = require("./LeitungFormValidator");
class LeitungFormatter {
    static leitungslaenge(options) {
        return LeitungFormValidator_1.LeitungFormValidator.leitungslaenge(options);
    }
    static ueberstandFestpunkt(options) {
        return LeitungFormValidator_1.LeitungFormValidator.ueberstandFestpunkt(options);
    }
    static ueberstandMitnehmer(options) {
        return LeitungFormValidator_1.LeitungFormValidator.ueberstandMitnehmer(options);
    }
    static biegeradiusMin(options) {
        return LeitungFormValidator_1.LeitungFormValidator.biegeradiusMin(options);
    }
    static aussendurchmesser(options) {
        return LeitungFormValidator_1.LeitungFormValidator.aussendurchmesser(options);
    }
    static gewicht(options) {
        return LeitungFormValidator_1.LeitungFormValidator.gewicht(options);
    }
    static gewichtKgProM(options) {
        return LeitungFormValidator_1.LeitungFormValidator.gewichtKgProM(options);
    }
    static kupferzahl(options) {
        return LeitungFormValidator_1.LeitungFormValidator.kupferzahl(options);
    }
}
exports.LeitungFormatter = LeitungFormatter;
//# sourceMappingURL=LeitungFormatter.js.map